import { render } from "./AfiliadosML.vue?vue&type=template&id=10ebcb9c&scoped=true"
import script from "./AfiliadosML.vue?vue&type=script&lang=js"
export * from "./AfiliadosML.vue?vue&type=script&lang=js"

import "./AfiliadosML.vue?vue&type=style&index=0&id=10ebcb9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ebcb9c"]])

export default __exports__